module.exports = __webpack_public_path__ + "static/img/son8_active.7cf1da2b.png";